module.exports = __webpack_public_path__ + "static/img/zuowei_pat.e5d4854.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zuowei_pat.png
// module id = sXTQ
// module chunks = 122